export default __webpack_public_path__ + "static/media/bg-mobile.2214571d.jpg";